import './styles.scoped.css';

import { FC } from "react";

type Props = {
  icons: string[]; 
  isReversed?: boolean;
  className?: string;
};



const InfiniteScroll: FC<Props> = ({ icons, isReversed = false, className }) => {
  return (
    <div className={`infinite-scroll-container ${className ?? ""}`}>
      <div
        className={`infinite-scroll-track ${
          isReversed ? "reverse" : ""
        }`}
      >
        {icons.concat(icons).map((src, i) => (
          <div key={i} className="icon-wrapper">
            <img src={src} alt="tech icon" className="icon" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default InfiniteScroll;
